import React, {Component} from 'react'
import PropTypes from 'prop-types'
import StyleSheet from 'styles'

export class ActionIndicator extends Component {
  static propTypes = {
    on: PropTypes.bool
  }

  render = () =>
    <span className={styles({actionIndicator: true, on: !!this.props.on})} />
}

const styles = StyleSheet({
  actionIndicator: {
    display: 'inline-block',
    width: 13,
    height: 13,
    borderRadius: 6,
    backgroundColor: '#cfcfcf',
    '&$on': {
      backgroundColor: '#6AAEAA',
    }
  },
  on: {},
})